module.exports = __webpack_public_path__ + "img/Billionaire-6.9681ae59.png";